import React, { SVGProps } from 'react';

const SvgDesign = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="127"
    height="81"
    viewBox="0 0 127 81"
    {...props}
  >
    <g
      fill="none"
      fillRule="evenodd"
    >
      <g stroke="#080808">
        <g>
          <path
            strokeLinecap="square"
            d="M31.385 0.366L31.385 29.634"
            transform="translate(-896 -1699) translate(896 1700)"
          />

          <path
            d="M31.538 30.5c8.571 0 16.331 3.474 21.948 9.091 5.617 5.617 9.09 13.376 9.09 21.947h0v1.039H.5v-1.039c0-8.57 3.474-16.33 9.091-21.947 5.617-5.617 13.376-9.091 21.947-9.091z"
            transform="translate(-896 -1699) translate(896 1700)"
          />

          <path
            d="M31.154 62.5c4.323 0 8.236 1.752 11.069 4.585s4.585 6.746 4.585 11.069h0v1.038H15.5v-1.038c0-4.323 1.752-8.236 4.585-11.07 2.833-2.832 6.746-4.584 11.069-4.584z"
            transform="translate(-896 -1699) translate(896 1700) rotate(180 31.154 70.846)"
          />

          <path
            d="M51.859 37.871L51.859 16.819 125.717 16.819 125.717 70.846 51.859 70.846 51.859 63.077"
            transform="translate(-896 -1699) translate(896 1700)"
          />

          <path
            strokeLinecap="round"
            d="M56.788 43.313L56.788 21.833 120.788 21.833 120.788 65.833 56.788 65.833 56.788 62.677"
            transform="translate(-896 -1699) translate(896 1700)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgDesign;
